<template>
	<div>
		<el-row>
			<el-form class="search_form" :model="searchForm" ref="searchForm" size="mini" :inline="true">
				<el-col :span="3">
					<el-form-item prop="stationId">
						<el-cascader v-model="cascaderValue" :options="cascaderOptions"
							:props="{ expandTrigger: 'hover' }" @change="cascaderChange"
							:placeholder="$t('deviceControl.EnterKeywordSearch')" filterable></el-cascader>
					</el-form-item>
				</el-col>
				<el-col :span="3">
					<el-form-item prop="pileCode">
						<el-input :placeholder="$t('deviceControl.pileCode')" v-model="searchForm.pileCode"
							clearable></el-input>
					</el-form-item>
				</el-col>
				<!--        <el-col :span="3">-->
				<!--          <el-form-item prop="commandPort">-->
				<!--            <el-input placeholder="端口号" v-model="searchForm.commandPort" clearable></el-input>-->
				<!--          </el-form-item>-->
				<!--        </el-col>-->
				<el-col :span="4">
					<el-form-item>
						<el-button size="mini" type="primary" @click="resetSearchForm">{{ $t('deviceControl.empty')
							}}</el-button>
						<el-button type="primary" icon="el-icon-search" @click="submitSearchForm"
							:loading="searchLoading">{{ $t('deviceControl.search') }}
						</el-button>
					</el-form-item>
				</el-col>
			</el-form>
		</el-row>
		<el-table :data="pileDataTables" stripe style="width: 100%" ref="pileDataTable" border v-loading="listLoading">

			<!--                <af-table-column type="selection" width="30"></af-table-column>-->
			<af-table-column prop="stationName" :label="$t('deviceControl.stationName')"></af-table-column>
			<af-table-column prop="name" :label="$t('deviceControl.name')"></af-table-column>
			<af-table-column prop="pileCode" :label="$t('deviceControl.pileCode')"></af-table-column>
			<af-table-column prop="currentType.message" :label="$t('deviceControl.currentType')"></af-table-column>
			<af-table-column prop="faultOrService.message"
				:label="$t('deviceControl.faultOrService')"></af-table-column>
			<af-table-column prop="ratedPower" :label="$t('deviceControl.ratedPower')"></af-table-column>
			<af-table-column prop="controlledPower" :label="$t('deviceControl.controlledPower')"></af-table-column>
			<af-table-column :label="$t('deviceControl.operation')" width="350">
				<template slot-scope="scope">
					<el-popover style="margin-right: 10px;" placement="top" width="160">
						<el-form class="faultListing" :model="faultListingForm" ref="faultListingForm" size="mini">
							<p style="text-align: center; background-color: white;color:red">
								{{ $t('deviceControl.AreYouSure3') }}<br><span style="color: #2c3e50">{{
				scope.row.pileCode }}</span>？</p>
							<el-col>
								<el-form-item hidden label="id" :label-width="formLabelWidth" prop="id">
									<el-input v-model="faultListingForm.id" autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
						</el-form>
						<div style="text-align: center">
							<el-button type="primary" size="mini" @click="faultListingFormSubmit(scope.row)"
								:loading="faultListingSubmitLoading">{{ $t('deviceControl.confirm') }}</el-button>
						</div>
						<el-button slot="reference" size="mini"
							v-if="checkPermission(['bee:res:deviceControl:faultListing'])" class="faultListing" plain
							@click="faultListing(scope.$index, scope.row)">{{ $t('deviceControl.faultListing') }}
						</el-button>
					</el-popover>
					<el-popover style="margin-right: 10px;" placement="top" width="160">
						<el-form class="inspectionAndMaintenance" :model="inspectionAndMaintenanceForm"
							ref="remotelyStopForm" size="mini">
							<p style="text-align: center; background-color: white;color:red">
								{{ $t('deviceControl.AreYouSure3') }}<br><span style="color: #2c3e50">{{
				scope.row.pileCode }}</span>？</p>
							<el-col>
								<el-form-item hidden label="id" :label-width="formLabelWidth" prop="id">
									<el-input v-model="inspectionAndMaintenanceForm.id" autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
						</el-form>
						<div style="text-align: center">
							<el-button type="primary" size="mini" @click="inspectionAndMaintenanceSubmit(scope.row)"
								:loading="inspectionAndMaintenanceSubmitLoading">{{ $t('deviceControl.confirm')
								}}</el-button>
						</div>
						<el-button slot="reference" size="mini" class="inspectionAndMaintenance"
							v-if="checkPermission(['bee:res:deviceControl:inspectionAndMaintenance'])" plain
							@click="inspectionAndMaintenance(scope.$index, scope.row)">{{
				$t('deviceControl.InspectionAndMaintenance') }}
						</el-button>
					</el-popover>
					<el-popover style="margin-right: 10px;" placement="top" width="160">
						<el-form class="powerControl" :model="powerControlForm" :rules="checkPower"
							ref="powerControlForm" size="mini">
							<el-col>
								<el-form-item prop="controlledPower">
									<el-input :placeholder="$t('deviceControl.power')"
										v-model="powerControlForm.controlledPower" clearable>
									</el-input>
								</el-form-item>
							</el-col>
						</el-form>
						<div style="text-align: center">
							<!--                <el-button size="mini" @click="visible = false">关闭</el-button>-->
							<el-button type="primary" size="mini" @click="powerControlSubmit(scope.row)"
								:loading="powerControlSubmitLoading">{{ $t('deviceControl.control') }}</el-button>
						</div>
						<el-button slot="reference" size="mini"
							v-if="checkPermission(['bee:res:deviceControl:powerControl'])" class="powerControl" plain
							@click="powerControl(scope.$index, scope.row)">{{ $t('deviceControl.powerControl') }}
						</el-button>
					</el-popover>

					<el-popover style="margin-right: 10px;" placement="top" width="160">
						<div style="text-align: center;padding-bottom: 5px">
							<el-button type="primary" size="mini" @click="whitelistControlSubmit(scope.row)"
								:loading="whitelistControlSubmitLoading">{{ $t('que-ren-xia-fa') }}</el-button>
						</div>
						<el-form class="whitelistControl" :model="whitelistControlForm" :rules="checkWhitelist"
							ref="whitelistControlFormRef" size="mini">
							<el-col>
								<el-form-item prop="controlledWhitelistType">
									<el-select :placeholder="$t('qing-xuan-xia-fa-lei-xing')" filterable clearable
										collapse-tags v-model="whitelistControlForm.controlledWhitelistType">
										<el-option v-for="item in whitelistTypes" :key="item.value"
											:label="item.message" :value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col>
								<el-form-item prop="controlledWhitelistStatus">
									<el-select :placeholder="$t('qing-xuan-bai-ming-dan-zhuang-tai')" filterable
										clearable collapse-tags
										v-model="whitelistControlForm.controlledWhitelistStatus">
										<el-option v-for="item in whitelistStatuss" :key="item.value"
											:label="item.message" :value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col>
								<el-form-item prop="expiryDayNumber">
									<el-input :placeholder="$t('qing-shu-ru-guo-qi-tian-shu')"
										v-model="whitelistControlForm.expiryDayNumber" clearable>
									</el-input>
								</el-form-item>
							</el-col>
							<el-col>
								<el-form-item prop="controlledWhitelist">
									<el-select :placeholder="$t('qing-xuan-ze-chong-dian-ka')" multiple filterable
										clearable collapse-tags v-model="whitelistControlForm.controlledWhitelist">
										<el-option v-for="item in cascaderCards" :key="item.cardNo" :label="item.cardNo"
											:value="item.cardNo">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-form>
						<el-button slot="reference" size="mini"
							v-if="checkPermission(['bee:res:deviceControl:whitelistControl'])" class="whitelistControl"
							plain @click="whitelistControl(scope.$index, scope.row)">{{ $t('bai-ming-dan') }}
						</el-button>
					</el-popover>

          <el-popover style="margin-right: 10px;" placement="top" width="550">
            <el-form :model="chargingProfileControlForm" :rules="checkchargingProfile"
                     ref="chargingProfileControlFormRef" size="mini" class="edit_form">
              <div style="padding-bottom: 5px">配置文件：</div>
              <el-col :span="12">
                <el-form-item prop="chargingProfilePurpose">
                  <el-select   class="chargingProfile" placeholder="计划类型" filterable
                             clearable collapse-tags @change="changeConnectorId(scope.row)"
                             v-model="chargingProfileControlForm.chargingProfilePurpose">
                    <el-option v-for="item in chargingProfilePurposes" :key="item.value"
                               :label="item.message" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="connectorId">
                  <el-input class="chargingProfile" placeholder="枪口号"  @change="changeConnectorId(scope.row)"
                            v-model="chargingProfileControlForm.connectorId" clearable>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="stackLevel">
                  <el-input class="chargingProfile" placeholder="优先级别(1~10)"
                            v-model="chargingProfileControlForm.stackLevel" clearable>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item v-if="chargingProfileControlForm.chargingProfilePurpose == 'TxProfile'" prop="transactionId">
                  <el-input class="chargingProfile"  placeholder="充电请求"
                            v-model="chargingProfileControlForm.transactionId" clearable>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item v-if="chargingProfileControlForm.chargingProfilePurpose != 'TxProfile'" prop="validFrom">
                  <el-date-picker  type="datetime" size="mini" v-model="chargingProfileControlForm.validFrom"
                                  :picker-options="pickerOptions" value-format="yyyyMMddHHmmss" placeholder="生效时间点（可选）"
                                  style="width: 175px"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item v-if="chargingProfileControlForm.chargingProfilePurpose != 'TxProfile'" prop="validTo">
                  <el-date-picker type="datetime" size="mini" v-model="chargingProfileControlForm.validTo"
                                  :picker-options="pickerOptions" value-format="yyyyMMddHHmmss" placeholder="结束时间点（可选）"
                                  style="width: 175px"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="chargingProfileKind">
                  <el-select class="chargingProfile" placeholder="执行类型"  filterable
                             clearable collapse-tags v-model="chargingProfileControlForm.chargingProfileKind">
                    <el-option v-for="item in chargingProfileKinds" :key="item.value" :label="item.message"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="recurrencyKind">
                  <el-select class="chargingProfile" placeholder="循环周期（可选）"  filterable
                             clearable collapse-tags v-model="chargingProfileControlForm.recurrencyKind">
                    <el-option v-for="item in recurrencyKinds" :key="item.value" :label="item.message"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <div style="padding-bottom: 5px">执行计划：</div>
              <el-col>
                    <el-form-item prop="limitedTime">
                      <el-row  v-for="(item, i) in limitedTimeChargingForm.limitedTime" :key="i">
                        <el-col :span="4">
                          <el-time-select
                            class="limitedTimePicker"
                            :placeholder="$t('deviceControl.StartingTime')"
                            v-model="item[0]"
                            :picker-options="{
                              start: '00:00',
                              step: '00:10',
                              end: '24:00',
                              minTime: i > 0 && limitedTimeChargingForm.limitedTime[i - 1][1] ? limitedTimeChargingForm.limitedTime[i - 1][1].split(':')[0] + ':' + (limitedTimeChargingForm.limitedTime[i - 1][1].split(':')[1] - 1): '',
                            }"
                          ></el-time-select>
                        </el-col>
                        <el-col :span="4">
                        <el-time-select
                          class="limitedTimePicker"
                          :placeholder="$t('deviceControl.EndTime')"
                          v-model="item[1]"
                          :picker-options="{
                            start: '00:00',
                            step: '00:10',
                            end: '24:00',
                            minTime: limitedTimeChargingForm.limitedTime[i][0],
                          }"
                        ></el-time-select>
                        </el-col>
                        <el-col :span="4">
                        <el-form-item  prop="limit" >
                          <el-input class="chargingProfile" placeholder="周期限制值" v-model="item[2]" clearable></el-input>
                        </el-form-item>
                        </el-col>
                        <el-col :span="4">
                        <el-form-item prop="numberPhases" >
                          <el-select class="chargingProfile" placeholder="限制类型" filterable
                                     clearable collapse-tags v-model="item[3]">
                            <el-option v-for="item in numberPhasess" :key="item.value" :label="item.message"
                                       :value="item.value">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        </el-col>
                      </el-row>
                    </el-form-item>
                    <div style="text-align: center">
                      <el-button type="success" size="mini" @click="addLimitedTimeCharging" >{{$t('deviceControl.Add')}}</el-button>
                      <el-button type="danger"  size="mini" @click="deleteLimitedTimeCharging" >{{$t('deviceControl.delete')}}</el-button>
                    </div>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="chargingRateUnit">
                  <el-select class="chargingProfile" placeholder="限制类型" filterable
                             clearable collapse-tags v-model="chargingProfileControlForm.chargingSchedule.chargingRateUnit">
                    <el-option v-for="item in chargingRateUnits" :key="item.value" :label="item.message"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="duration">
                  <el-input class="chargingProfile" placeholder="限制持续时间（可选）秒" v-model="chargingProfileControlForm.chargingSchedule.duration" clearable>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="startSchedule">
                  <el-date-picker type="datetime" size="mini" v-model="chargingProfileControlForm.chargingSchedule.startSchedule"
                                  :picker-options="pickerOptions" value-format="yyyyMMddHHmmss" placeholder="限制开始时间（可选）"
                                  style="width: 175px"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="minChargingRate">
                  <el-input class="chargingProfile" placeholder="最低充电率（可选）"
                            v-model="chargingProfileControlForm.chargingSchedule.minChargingRate" clearable>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-form>
            <el-button slot="reference" size="mini"
                       v-if="checkPermission(['bee:res:deviceControl:chargingProfileControl'])" class="chargingProfileControl"
                       plain @click="chargingProfileControl(scope.$index, scope.row)">功率电流限制计划
            </el-button>
            <div style="text-align: center;padding-bottom: 5px">
              <el-button type="primary" size="mini" @click="chargingProfileControlSubmit(scope.row)"
                         :loading="chargingProfileControlSubmitLoading">{{ $t('que-ren-xia-fa') }}</el-button>
            </div>
          </el-popover>

        </template>
      </af-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparam" @callFather="changePage"></Pagination>
  </div>
</template>

<script>
import Pagination from '@/module/operatingCenter/component/Pagination'
import deviceControlApi from '../../api/deviceControlApi'
import pileApi from '../../../resourceCenter/api/pileApi';
import {
	isInteger
} from '../../../../common/validator'
import i18n from '../../../../lang/index'
export default {
	name: "pile",
	data() {
		return {
			formLabelWidth: '150px',
			searchForm: {},
			pileDataTables: [],
			searchLoading: false,
			listLoading: false,
			cascaderValue: [],
			cascaderOptions: [],
			cascaderCards: [],
      // 时间选择器
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
        shortcuts: [{
          text: this.$t('jin-tian'),
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: this.$t('zuo-tian'),
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: this.$t('yi-zhou-qian'),
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
			whitelistTypes: [
				{
					value: "Differential",
					message: i18n.t('zhui-jia')
				},
				{
					value: "Full",
					message: i18n.t('wan-quan')
				},
			],
			whitelistStatuss: [
				{
					value: "Accepted",
					message: i18n.t('tong-yi')
				},
				{
					value: "Blocked",
					message: i18n.t('zu-sai')
				},
				{
					value: "Expired",
					message: i18n.t('qi-man')
				},
				{
					value: "Invalid",
					message: i18n.t('wu-xiao-de')
				},
			],
      chargingProfilePurposes: [
        {
          value: "ChargePointMaxProfile",
          message: "全局计划"
        },
        {
          value: "TxDefaultProfile",
          message: "默认计划"
        },
        {
          value: "TxProfile",
          message: "充电请求指定计划"
        },
      ],
      chargingProfileKinds: [
        {
          value: "Absolute",
          message: "固定时间点"
        },
        {
          value: "Recurring",
          message: "循环使用"
        },
        {
          value: "Relative",
          message: "特定充电请求"
        },
      ],
      recurrencyKinds: [
        {
          value: "Daily",
          message: "天"
        },
        {
          value: "Weekly",
          message: "周"
        },
      ],
      chargingRateUnits: [
        {
          value: "W",
          message: "瓦特（功率）"
        },
        {
          value: "A",
          message: "安培（电流）"
        },
      ],
      numberPhasess: [
        {
          value: "1",
          message: "1"
        },
        {
          value: "3",
          message: "3"
        },
      ],
			// 编辑与添加
			editForm: {},
			// rules表单验证
			rules: {
				userSex: [{
					required: true,
					message: '',
					trigger: 'blur'
				}]
			},
			checkPower: {
				controlledPower: [{
					required: true,
					message: this.$t('deviceControl.PleaseInputPower'),
					trigger: 'blur'
				}, {
					validator: isInteger,
					trigger: 'blur'
				}]
			},
			checkWhitelist: {
				controlledWhitelist: [{
					required: true,
					message: i18n.t('qing-xuan-ze-chong-dian-ka-0'),
					trigger: 'blur'
				}],
				controlledWhitelistType: [{
					required: true,
					message: i18n.t('qing-xuan-ze-bai-ming-dan-xia-fa-lei-xing'),
					trigger: 'blur'
				}],
				controlledWhitelistStatus: [{
					required: true,
					message: i18n.t('qing-xuan-ze-bai-ming-dan-zhuang-tai'),
					trigger: 'blur'
				}],
				expiryDayNumber: [{
					required: true,
					message: i18n.t('qing-shu-ru-guo-qi-tian-shu'),
					trigger: 'blur'
				}, {
					validator: isInteger,
					trigger: 'blur'
				}]
			},
      checkchargingProfile: {
        chargingProfilePurpose: [{
          required: true,
          message: "请选择计划类型",
          trigger: 'blur'
        }],
        transactionId: [{
          required: true,
          message: "充电请求单号不能为空",
          trigger: 'blur'
        }],
        connectorId: [{
          required: true,
          message: "请输入枪口号",
          trigger: 'blur'
        }],
        stackLevel: [{
          required: true,
          message: "请输入优先级别",
          trigger: 'blur'
        }],
        chargingProfileKind: [{
          required: true,
          message: "请选择执行类型",
          trigger: 'blur'
        }],
        chargingRateUnit: [{
          required: true,
          message: "请选择限制类型",
          trigger: 'blur'
        }],
      },
			// 分页参数
			pageparam: {
				t: {},
				currentPage: 1,
				pageSize: 10,
				total: 0
			},
			faultListingForm: {},
			faultListingFormVisible: false,
			faultListingSubmitLoading: false,
			inspectionAndMaintenanceForm: {},
			inspectionAndMaintenanceFormVisible: false,
			inspectionAndMaintenanceSubmitLoading: false,
			powerControlForm: {},
			powerControlFormVisible: false,
			powerControlSubmitLoading: false,
			whitelistControlForm: {},
			whitelistControlFormVisible: {},
			whitelistControlSubmitLoading: false,
      chargingProfileControlForm: {
        transactionId:null,
        chargingSchedule:{
          chargingRateUnit:null,
          duration: null,
          startSchedule: null,
          minChargingRate: null
        }
      },
      chargingProfileControlVisible: {},
      chargingProfileControlSubmitLoading: false,
      limitedTimeChargingForm: {
        limitedTime: [["00:00", "24:00"]],
      },
      limitedTimeChargingVisible: false,
      limitedTimeChargingSubmitLoading: false,
      limitedTimeChargingFormRules: {
        canChargeTime: [
          {
            require: true,
            message: i18n.t('deviceControl.TimeCannotBeEmpty'),
            trigger: "blur",
          },
        ],
      },
		}
	},
	// 注册组件
	components: {
		Pagination
	},
	created() { },
	watch: {
		"$ref.whitelistControlFormRef": (newValue, oldValue) => {
			console.log(newValue, oldValue)
		}
	},
	methods: {
		resetSearchForm() {
			this.cascaderValue = []
			this.searchForm = {}
			this.submitSearchForm()
		},
		async submitSearchForm() {
			this.searchLoading = true;
			this.listLoading = true;
			// let param = Object.assign({}, this.stationSearchForm)
			// para.date = (!para.date || para.date == '') ? '' : util.formatDate.format(new Date(para.date), 'yyyy-MM-dd');
			this.pageparam.t = this.searchForm;
			let param = Object.assign({}, this.pageparam);
			try {
				const res = await deviceControlApi.getPilePageList(param)
				if (res.code === 0) {
					this.pageparam.total = res.data.total;
					this.pileDataTables = res.data.records;
					//this.$emit('setPileDataTable',res.data.records);
					// this.$message({
					//   message: res.message,
					//   type: 'success'
					// });
				} else {
					this.$message.error(res.message);
				}
			} catch (error) {
				console.log(error)
			}

			this.searchLoading = false;
			this.listLoading = false;
		},
		getCascaderCards() {
			let operatorId = this.$store.getters.operatorIds.length == 0 ? '' : this.$store.getters.operatorIds[0]
			const userType = this.$store.getters.userType
			if (userType.toLowerCase().indexOf('admin') != 1) {
				operatorId = null
			}
			let params = {
				operatorId: operatorId,
				cardState: "normal"
			}
			deviceControlApi.getCascaderCards(JSON.stringify(params)).then((res) => {
				if (res.code === 0) {
					this.cascaderCards = res.data
				}
			});
		},
		getCascaderOptions() {
			let operatorId = this.$store.getters.operatorIds.length == 0 ? '' : this.$store.getters.operatorIds[0]
			const userType = this.$store.getters.userType
			if (userType.toLowerCase().indexOf('admin') != 1) {
				operatorId = null
			}
			deviceControlApi.getCascaderOptions(operatorId).then((res) => {
				if (res.code === 0) {
					let data = []
					let province = res.data.provinceMap
					let city = res.data.cityMap
					let station = res.data.nameMap
					for (let i = 0; i < province.length; i++) {
						console.log(province)
						data[i] = {
							label: province[i].province,
							children: []
						}
						for (let j = 0; j < city.length; j++) {
							if (data[i].label === city[j].province) {
								data[i].children[data[i].children.length] = {
									label: city[j].city,
									// value:'city:'+city[j].city,
									children: []
								}
								for (let n = 0; n < station.length; n++) {
									if (data[i].children[data[i].children.length - 1].label === station[n]
										.city) {
										data[i].children[data[i].children.length - 1].children.push({
											label: station[n].stationName,
											value: station[n].id,
										})
									}
								}
							}
						}
					}
					this.cascaderOptions = data
				}
			});
		},
		cascaderChange(value) {
			this.searchForm.stationId = value[2]
		},
		changePage() {
			this.submitSearchForm();
		},
		faultListing() {

		},
		faultListingFormSubmit(row) {
			this.faultListingForm = row.id;
			let param = JSON.stringify(this.faultListingForm);
			deviceControlApi.faultListing(param).then((res) => {
				if (res.code === 0) {
					this.$message({
						message: res.message,
						type: 'success'
					})
				} else {
					this.$message.info(res.message)
				}
			})
		},

		inspectionAndMaintenance() {

		},
		inspectionAndMaintenanceSubmit(row) {
			this.faultListingForm = row.id;
			let param = JSON.stringify(this.faultListingForm);
			deviceControlApi.inspectionAndMaintenance(param).then((res) => {
				if (res.code === 0) {
					this.$message({
						message: res.message,
						type: 'success'
					})
				} else {
					this.$message.info(res.message)
				}
			})
		},
		powerControl() {

		},
		powerControlSubmit(row) {
			this.powerControlSubmitLoading = true
			this.powerControlForm.id = row.id
			let param = JSON.stringify(this.powerControlForm)
			deviceControlApi.powerControl(param).then((res) => {
				if (res.code === 0) {
					this.$message({
						message: res.message,
						type: 'success'
					})
					row.controlledPower = this.powerControlForm.controlledPower
				} else {
					this.$message.error(res.message)
				}
			})
			this.powerControlSubmitLoading = false
		},
		whitelistControl() { },
		whitelistControlSubmit(row) {
			this.whitelistControlSubmitLoading = true
			this.whitelistControlForm.id = row.id
			let param = JSON.stringify(this.whitelistControlForm)
			deviceControlApi.whitelistControl(param).then((res) => {
				if (res.code === 0) {
					this.$message({
						message: res.message,
						type: 'success'
					})
					row.controlledWhitelist = this.whitelistControlForm.controlledWhitelist
				} else {
					this.$message.error(res.message)
				}
			})
			this.whitelistControlSubmitLoading = false

		},
    chargingProfileControl(){},
    chargingProfileControlSubmit(row) {
      this.chargingProfileControlSubmitLoading = true
      this.chargingProfileControlForm.id = row.id
      let lt = this.limitedTimeChargingForm.limitedTime;
      /*let flag = false;
      let msg = "";
      for (var i = 0; i < lt.length; i++) {
        msg = lt[i][0] === null || lt[i][1] === null ? this.$t('deviceControl.TimeCannotBeEmpty2') : "";
        if (msg !== "") { break; }
        for (var j = 0; j < lt.length; j++) {
          if (i != j) {
            flag = (lt[i][0] > lt[j][0] && lt[i][0] < lt[j][1]) || (lt[i][1] > lt[j][0] && lt[i][1] < lt[j][1]);
            if (flag) { break; }
          }
        }
      }
      if (msg !== "" || flag) {
        this.$message.error(msg !== "" ? msg : this.$t('deviceControl.TimeCannotBeEmpty3'));
        return;
      }*/
      let schedulePeriods =  []
      for (var i = 0; i < lt.length; i++) {
        let obj = {};
        obj.startPeriod = parseInt(lt[i][0].split(":")[0]) * 60 * 60 + parseInt(lt[i][0].split(":")[1]) * 60
        obj.limit = lt[i][2]
        obj.numberPhases = lt[i][3]
        schedulePeriods.push(obj)
      }
      if(this.chargingProfileControlForm.transactionId){
        this.chargingProfileControlForm.transactionId = this.chargingProfileControlForm.transactionId.substr(this.chargingProfileControlForm.transactionId.length - 6)
      }
      this.chargingProfileControlForm.chargingSchedule.chargingSchedulePeriod = schedulePeriods;
      let param = JSON.stringify(this.chargingProfileControlForm)
      deviceControlApi.chargingProfileControl(param).then((res) => {
        if (res.code === 0) {
          this.$message({
            message: res.message,
            type: 'success'
          })
        } else {
          this.$message.error(res.message)
        }
      })
      this.chargingProfileControlSubmitLoading = false

    },
    addLimitedTimeCharging() {
      let length = this.limitedTimeChargingForm.limitedTime.length;
      if (length < 6) {
        console.log("length:" + length);
        if (length > 0) {
          console.log(this.limitedTimeChargingForm.limitedTime[length - 1][1]);
          if (this.limitedTimeChargingForm.limitedTime[length - 1][1] != "24:00") {
            this.limitedTimeChargingForm.limitedTime.push([this.limitedTimeChargingForm.limitedTime[length - 1][1], "24:00"]);
          } else {
            this.$message.error(this.$t('deviceControl.error1'));
          }
        } else {
          this.limitedTimeChargingForm.limitedTime.push(["00:00", "24:00"]);
        }
      } else {
        this.$message.error(this.$t('deviceControl.error2'));
      }
    },
    deleteLimitedTimeCharging() {
      this.limitedTimeChargingForm.limitedTime.splice(this.limitedTimeChargingForm.limitedTime.indexOf(["00:00", "24:00"]), 1);
    },
    changeConnectorId(row){
		  if(this.chargingProfileControlForm.connectorId && this.chargingProfileControlForm.chargingProfilePurpose == 'TxProfile'){
        let gunCode = ""
        if(this.chargingProfileControlForm.connectorId >= 10){
          gunCode = row.pileCode +  this.chargingProfileControlForm.connectorId
        }else{
          gunCode = row.pileCode + "0" + this.chargingProfileControlForm.connectorId
        }
        deviceControlApi.getChargeByGunCode(gunCode).then((res) => {
          if (res) {
            this.chargingProfileControlForm.transactionId = res.chargeOrderNo
            console.info(this.chargingProfileControlForm.transactionId)
          } else {
            this.chargingProfileControlForm.transactionId = null
          }
        })
      }else{
        this.chargingProfileControlForm.transactionId = null
      }
    }

	},
	mounted: function () {
		this.submitSearchForm()
		this.getCascaderOptions()
		this.getCascaderCards()
	},
	filters: {
		statusFilter(runStatus) {
			const statusMap = {
				0: 'success',
				1: 'info',
				2: 'danger',
				3: 'warning'
			}
			return statusMap[runStatus]
		}
	},
	props: {
		pileDataTable: ""
	}
}
</script>

<style lang="less" scoped>
  .el_search {
    background-color: teal;
    color: white;
  }

  .el_clear {
    background-color: darkorange;
    color: white;
  }

  .sendQRCode {
    background-color: #b2e042;
    color: white;
  }

  .remotelyControl {
    background-color: #1cbcff;
    color: white;
  }

  .sendRate {
    background-color: #12d900;
    color: white;
  }

  .faultListing {
    background-color: #b91797;
    color: white;
  }

  .inspectionAndMaintenance {
    background-color: #00eabb;
    color: white;
  }

  .powerControl {
    background-color: #00a9b9;
    color: white;
  }

  .whitelistControl {
	  background-color: #13b900;
	  color: white;
  }
  .limitedTimeCharging {
    background-color: #d949c8;
    color: white;
  }
  .limitedTimePicker {
     width: 96px;
     margin-bottom: 2px;
   }
  .chargingProfile {
    width: 180px;
    margin-bottom: 2px;
  }
  /deep/ .edit_form {
    /*height: 600px;*/
    overflow: auto;

    .el-form-item__label {
      color: rgba(0, 0, 0, 0.47);
    }
  }

</style>



// WEBPACK FOOTER //
// src/module/operatingCenter/page/deviceControl/pile.vue